export default __webpack_public_path__ + "static/media/talk-to-astrologer.0ed9c532.png";